import { ISaveSupportType, ISupportType, supportApi } from '../../shared';
import { NewBaseClient } from '../../shared/clients/new-base.client';

class SupportTypeClient extends NewBaseClient<ISaveSupportType, ISupportType> {
    constructor() {
        super(supportApi, '/support-types');
    }
}

export const supportTypeClient = new SupportTypeClient();
